import { ENDPIONTS, httpService } from "@api";
import { KRA } from "@models";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

interface Props {
  selectedKRA?: KRA;
  callback?: () => void;
}

const NewKRA = ({ selectedKRA, callback }: Props) => {
  const { register, handleSubmit, errors } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: any, e: any) => {
    setIsLoading(true);

    const kra: Partial<KRA> = {
      name: data.name,
    };

    if (selectedKRA?.id) {
      kra.id = selectedKRA.id;
      const res = await httpService(ENDPIONTS.kras).update(selectedKRA.id, kra);
    } else {
      const res = await httpService(ENDPIONTS.kras).post(kra);
      if (res.status === 201) {
        Swal.fire({
          icon: "success",
          text: "New KRA has been successfully registered.",
          showConfirmButton: false,
        });
      }
    }

    callback?.();
    setIsLoading(false);
    e.target.reset();
  };

  return (
    <>
      <h4>Add New KRA</h4>
      <hr />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Key Result Area</label>
              <div className="col-12">
                <input
                  defaultValue={selectedKRA?.name}
                  type="text"
                  className="form-control"
                  placeholder="Enter payroll group name"
                  name="name"
                  ref={register({ required: true })}
                />
              </div>
            </div>
          </div>
        </div>

        <input
          type="submit"
          name="time"
          className="btn btn-primary"
          disabled={isLoading}
          value={
            isLoading
              ? "Please wait..."
              : selectedKRA?.id
              ? "Update"
              : "Register"
          }
        />
      </form>
    </>
  );
};

export default NewKRA;
